import { startOfDay, endOfDay, startOfWeek, endOfWeek, format, formatISO } from "date-fns";
import { DATE_FORMAT } from "../appointment-schedule.constants.js";
const formatDate = (date, dateOnly) => dateOnly ? format(date, DATE_FORMAT) : formatISO(date);
const getViewTimePeriod = (calendarViewType, currentDate, formatDateOnly = false) => {
  if (!currentDate)
    return {
      start: null,
      end: null
    };
  switch (calendarViewType) {
    case "week":
      return {
        start: formatDate(startOfWeek(currentDate, { weekStartsOn: 1 }), formatDateOnly),
        end: formatDate(endOfWeek(currentDate, { weekStartsOn: 1 }), formatDateOnly)
      };
    default:
      return {
        start: formatDate(startOfDay(currentDate), formatDateOnly),
        end: formatDate(endOfDay(currentDate), formatDateOnly)
      };
  }
};
export {
  getViewTimePeriod
};
